import React from 'react';
import classes from './LargePostsView.module.css';

const largePostsView = (props) => {
  return (
    <svg
      className={classes.OuterSVG}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15.03"
      viewBox="0 0 16 15.03"
      stroke={props.fillColor ? props.fillColor : '#000'}
    >
      <g id="Component_1065" transform="translate(-2.799 -3.03)">
        <g
          id="Rectangle_5828"
          fill={props.fillColor ? props.fillColor : '#000'}
          stroke={props.fillColor ? props.fillColor : '#000'}
          transform="translate(2.799 3.03)"
        >
          <rect width="16" height="11" stroke="none" rx="1" />
          <rect width="15" height="10" x=".5" y=".5" fill="none" rx=".5" />
        </g>
        <path id="Line_1063" d="M0 0L9.251 0" transform="translate(3.327 17.561)" />
        <path id="Line_1064" d="M0 0L12.097 0" transform="translate(3.327 16.138)" />
      </g>
    </svg>
  );
};

export default largePostsView;
